import {api} from '../constants/cards_constants';
import { setCards, addCard, removeCard, editCard } from '../state/ducks/cards';
import { httpClient } from './httpClient';
import log from './logger/log';
import { dispatch } from '../state/store';

const getCardsAsync = async (filter, token) => {
    const url = api.GET_CARDS_LIST_API;

    let postData = {
        pageNumber: filter.pagesFilter.currentPage,
        modelFilter: filter.modelFilter,
        sortFilter: filter.sortFilter
    }
    
    try {
        if(token) {
            token.throwIfCanceled();
        }
        const data = await httpClient.post(url, postData);
        let cards = {
            items: data.items,
            filter: {
                pagesFilter: { currentPage: data.currentPage, pageCount: data.pagesCount, maxItemsOnPage: data.maxItemsOnPage },
                modelFilter: filter.modelFilter,
                sortFilter: filter.sortFilter
            }
        }

        if(token) {
            token.throwIfCanceled();
        }
        dispatch(setCards(cards.items, cards.filter));
    }
    catch (error){
        log.error(JSON.stringify(error));
        throw error;
    }
};

const getCardAsync = async (cardId) => {
    const url = api.GET_CARD_API + "?id=" + cardId;
    try {
        const data = await httpClient.get(url);
        return data;
    }
    catch (error) {
        log.error(JSON.stringify(error))
        return null;
    }
};

const getCardByBarcodeAsync = async (barcode) => {
    const url = api.GET_CARD_BY_BARCODE_API + "?barcode=" + barcode;
    try {
        const data = await httpClient.get(url);
        return data;
    }
    catch (error) {
        if(error.statusCode === 404) {
            return null;
        }

        log.error(JSON.stringify(error))
        return null;
    }
};

const addCardAsync = async (newCard) => {
    const url = api.ADD_CARD_API;
    try {
        const card = await httpClient.post(url, newCard);        
        dispatch(addCard(card));
    }
    catch (error) {
        log.error(JSON.stringify(error))
    }
};

const editCardAsync = async (editedCard) => {
    const url = api.EDIT_CARD_API;
    try {
        const card = await httpClient.post(url, editedCard);
        dispatch(editCard(card));
    }
    catch (error) {
        log.error(JSON.stringify(error))
    }
};

const removeCardAsync = async (card) => {
    const url = api.REMOVE_CARD_API + "?id=" + card.cardId;
    try {
        await httpClient.get(url);
        dispatch(removeCard(card));
    }
    catch (error) {
        log.error(JSON.stringify(error))
    }
}

const cardService = {
    getCardsAsync,
    getCardAsync,
    getCardByBarcodeAsync,
    addCardAsync,
    editCardAsync,
    removeCardAsync
}

export default cardService;